<template>
  <div class="layout-topbar">
    <button class="p-link layout-menu-button" type="button" v-on:click="toggleSideBarVisible">
      <span class="pi pi-bars"></span>
    </button>
    <button class="p-link layout-signout-button">
      <span class="pi pi-sign-out" v-on:click="signOutClick"></span>
    </button>
    <ShoppingCard v-if="featureActive('shoppingCard')"></ShoppingCard>
    <RecentViewed v-if="featureActive('recentViewed')"></RecentViewed>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import ShoppingCard from "../components/ShoppingCard";
import RecentViewed from "@/components/RecentViewed";

export default {
  name: "AppTopBar",
  components: {
    RecentViewed,
    ShoppingCard
  },
  data() {
    return {
      menuVisible: false
    }
  },
  methods: {
    ...mapActions('nav', [
      'toggleSideBarVisible'
    ]),
    ...mapActions('auth', ['logout']),
    signOutClick() {
      this.logout().finally(
          this.$router.push('/signin')
      )
    }
  },
  computed: {
    ...mapGetters('config', ['featureActive']),
    // shoppingCard() {
    //   return this.featureActive('shoppingCard');
    // },
    // recentViewed() {
    //   return this.featureActive('recentViewed');
    // }
  }
}
</script>


<style scoped>

.alt-menu {
  position: fixed;
  top: 50px;
  left: 0;
  display: none;
}

.alt-menu.visible {
  display: inline-block;
}

</style>